// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._32RqLWb9TAlxHXLXW5Y7tH {\n    display: flex;\n    flex-direction: column;\n  }\n  ._32RqLWb9TAlxHXLXW5Y7tH a {\n    color: white;\n  }\n  ._32RqLWb9TAlxHXLXW5Y7tH li {\n    padding: 4px;\n  }\n  ._21_Zg-ByTQDDzrT0uY_Ufj {\n    font-size: 16px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n", ""]);
// Exports
exports.locals = {
	"welcomePage": "_32RqLWb9TAlxHXLXW5Y7tH",
	"footer": "_21_Zg-ByTQDDzrT0uY_Ufj"
};
module.exports = exports;
